/* Legado */
import Auth from '@/domains/Auth/vuex'
import Users from '@/domains/Users/vuex'
import Sessions from '@/domains/Sessions/vuex'
import Solutions from '@/domains/Solutions/vuex'
import Dashboard from '@/domains/Dashboard/vuex'
import ThematicPages from '@/domains/ThematicPages/vuex'
import Management from '@/domains/Management/vuex'
import Notifications from '@/domains/Notifications/vuex'
import Reports from '@/domains/Reports/vuex'
import Tracks from '@/domains/Tracks/vuex'
import Programs from '@/domains/Programs/vuex'
import Banners from '@/domains/Banners/vuex'
import Gamification from '@/domains/Gamification/vuex'
import Comments from '@/domains/Comments/vuex'
import Tools from '@/domains/Tools/vuex'
import Partners from '@/domains/Partners/vuex'
import Articles from '@/domains/Articles/vuex'

/* Novo modelo para criar storage. Utilizar sufixo "Module" para evitar conflitos */
import { EmailModule } from '@/modules/Notification/modules/Email'
import { FinanceModule } from '@/modules/Finance/modules/Finance'

const vuex = {
  Auth,
  Solutions,
  Users,
  Dashboard,
  Sessions,
  Tracks,
  Programs,
  Reports,
  ThematicPages,
  Management,
  Notifications,
  Banners,
  Gamification,
  EmailModule,
  FinanceModule,
  Comments,
  Tools,
  Partners,
  Articles
}
const keys = Object.keys(vuex)
const modules = keys.reduce((acc, key) => ({
  ...acc,
  [key]: vuex[key].module
}), {})

export default { modules }
